import React, { useEffect, useState } from "react";
import { useHistory ,useLocation} from "react-router";
import $ from "jquery";
import ReqService from '../../request/service';
import Waiter from './../../assets/gif/blueCircle.gif';
import { createGlobalStyle } from 'styled-components';
import axios from "axios";
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from '../../constants';
import {validateInput as _vli,validateAllUIInputs as _vlai,stringToHex} from "../forms/validator";
const GlobalStyles = createGlobalStyle`

.table {
		border:0px dotted #e0e0e0;
		
}
table.table th span { font-size:1rem; color:#909090; font-weight:400;}
table.table td  { font-size:0.85rem; color:#202020; font-weight:400; padding:8px 2px;}
.dataTables_filter input[type=search]
{
	border-radius:50rem!important;
	padding-left:1rem;
	padding-right:1rem;
	padding-top:0.2rem;
	padding-bottom:0.2rem;
	
}
div.dataTables_wrapper div.dataTables_length select {
   border-radius:50rem!important;
   padding-left:1rem;
	padding-right:1rem;
	padding-top:0.2rem;
	padding-bottom:0.2rem;
   width:120px;
}
div.dataTables_wrapper div.dataTables_length label{
	color:#404040;
	font-weight: 300;
    font-size: 0.875rem;
}
div.dataTables_wrapper div.dataTables_filter label {
    color:#404040;
	font-weight: 300;
    font-size: 0.875rem;
}
table.dataTable.table-striped>tbody>tr.odd>* {
    box-shadow: inset 0 0 0 9999px rgb(200 250 150 / 5%)!important;
}
.page-link {
	border:0px!important;
	font-size:12px;
}
.active>.page-link, .page-link.active {
    z-index: 3;
    color: #fff;
    background-color: #11b5ff;
    border-color: #11b5ff;
	box-shadow:1px 1px #999;
	border-radius:50rem;
}
.dataTables_info{
	font-size:12px;
	color:#495057;
}
`;

const JComponent = (props) => {
	const location=useLocation();
	const [assetsCategoryList,setAssetsCategoryList]=useState([]);
	const [implAgencyList,setImplAgencyList]=useState([]);
	const [userAgencyList,setUserAgencyList]=useState([]);
	const [cols,setCols]=useState([]);
	const [rows,setRows]=useState([]);
	const [fetchOnReq,setFecthOnReq]=useState(false);
	const [showQRBox,setShowQRBox]=useState(false);
	const [showActionBox,setShowActionBox]=useState(false);
	const [selectedVideo,setSelectedVideo]=useState("");

	const [actionType,setActionType]=useState("");
	const [remarks,setRemarks]=useState("");
	const [recordSlno,setRecordSlno]=useState(0);
	const [implAgencyId,setImplAgencyId]=useState("");
	const [implAgencyIdForward,setImplAgencyIdForward]=useState("");
	const [assetId,setAssetId]=useState("");
	const [disabled,setDisabled]=useState(false);
	const [actionRemarks,setActionRemarks]=useState([]);
	let _TX=1;
	useEffect(()=>{ 
		setCols(['Asset Type','Mobile','Remarks','Video','Service Rates','Date.Time','Implementing Agency','User Agnecy','Panchayat','Block']);
		if(_TX==1){
			_TX++;
			getRemarks();
		}
	},[]);
	
	useEffect(()=>{
		setTimeout(()=>{
		window["initTable"]("w3DListTable")
		},2000);
		
	},[rows])
	const getRemarks=async()=>{
			await loadImplAgencyList();
			await loadUserAgencyList();
			await loadAssetCategoryList();
			let stars=location.state?.stars;

			let _u="/api/remarks/get-remarks.php";
			let _d={
				token:localStorage.getItem("_xoxex"),
				email:localStorage.getItem("_xoxem"),
				stars:stars===undefined?"*":stars
			};
			console.log(_d);
			let idata=stringToHex(JSON.stringify(_d));	
			let _rows=[];
			setRows([]);	
			setFecthOnReq(true);
			
			var config = {
				method: 'post',
				url: API_CORE_SERVER+_u,
				headers: { 
					'Content-Type': 'application/x-www-form-urlencoded',
					//'Content-Type': 'application/json', 
				},
				data:"i="+idata
			  };
			axios(config)
				.then((response)=>{
					if(response.status===200 && response.data){
						let data=response.data;
						
						if(data.status===1 && data.data && data.data.length>0){
							let records=data.data;
							for(let i=0;i<records.length;i++){
								let assetId=records[i].assetId;
								let mobile=records[i].mobile;
								let remarks=records[i].remarks;
								let photo=records[i].photo;
								let rates=records[i].rates;
								let idate=records[i].idate;
								_rows.push({ 
									slno:records[i].slno,
									implAgencyId:records[i].implId,
									userAgency:records[i].userAgency,
									assetName:records[i].assetName,
									assetType:records[i].assetType,
									block:records[i].block,
									panchayat:records[i].panchayat,
									assetId:assetId,
									mobile:mobile,
									remarks:remarks,
									photo:photo,
									rates:rates,
									idate:idate,
									status:records[i].status_
									
								});
							}
						} // status==1
					} // status==200
					console.log("_rows");
					console.log(_rows);
					setRows(_rows);
					setFecthOnReq(false);
				}).catch((response)=>{
					setRows(_rows);
					setFecthOnReq(false);
				})
	}
	const getActionRemarks=async(_remarkId)=>{
		let _u="/api/remarks/get-remark-actions.php";
		let _d={
			token:localStorage.getItem("_xoxex"),
			email:localStorage.getItem("_xoxem"),
			remarkId:_remarkId
		};
		console.log(_d);
		let idata=stringToHex(JSON.stringify(_d));	
		let _rows=[];
		setActionRemarks([]);	
		var config = {
			method: 'post',
			url: API_CORE_SERVER+_u,
			headers: { 
				'Content-Type': 'application/x-www-form-urlencoded',
				//'Content-Type': 'application/json', 
			},
			data:"i="+idata
		  };
		await axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					let data=response.data;
					
					if(data.status===1 && data.data && data.data.length>0){
						let records=data.data;
						
						for(let i=0;i<records.length;i++){
							
							_rows.push({ 
								remarkId:records[i].remarkId,
								assetId:records[i].assetId,
								implId:records[i].implId,
								remarks:records[i].remarks,
								actionType:records[i].actionType,
								idate:records[i].idate
								
							});
						}
					} // status==1
				} // status==200
				console.log("_rows");
				console.log(_rows);
				setActionRemarks(_rows);
				
			}).catch((response)=>{
				setActionRemarks(_rows);
				
			})
	}
	const getAssetType=(_catId)=>{
		for(let i=0;i<assetsCategoryList.length;i++){
			if(assetsCategoryList[i].catId===_catId) return(assetsCategoryList[i].catName);
		}
		return(_catId);
	}
	const getImplAgencyById=(_id)=>{
		for(let i=0;i<implAgencyList.length;i++){
			if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
		}
		return(_id);
	}
	const getUserAgencyById=(_id)=>{
		for(let i=0;i<userAgencyList.length;i++){
			if(userAgencyList[i].userAgencyId===_id) return(userAgencyList[i].userAgencyName);
		}
		return(_id);
	}
	const loadAssetCategoryList=async()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_asset_category.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		await axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setAssetsCategoryList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	const loadImplAgencyList=async()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_impl_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		await axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setImplAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadUserAgencyList=async()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_user_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		await axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setUserAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  
	const submitForm=()=>{
		try{
			let dataset={
				slno:recordSlno,
				assetId:assetId,
				implId:implAgencyId,
				actionType:actionType,
				implIdForward:implAgencyIdForward,
				remarks:remarks,
				token:localStorage.getItem("_xoxex"),
				email:localStorage.getItem("_xoxem")
			}

			let idata=stringToHex(JSON.stringify(dataset));
			console.log(idata);
			setDisabled(true);
			$.post(API_CORE_SERVER+"/api/remarks/create-action.php","i="+idata,async function(result) {
					console.log(result);
					props.modalObject.waiting("",false);
					if(result.status===1){
					document.getElementById("actionType").value="";	
					document.getElementById("remarks").value="";
					props.modalObject.ok("Successfully Saved");
					setDisabled(false);
					setShowActionBox(false);
					} else props.modalObject.ok(result.msg);
					setDisabled(false);
			},'json')
			.fail(function(response) {
				props.modalObject.waiting("",false);
				if(response.status===404) props.modalObject.ok("Post URL not found!");
				else props.modalObject.ok("Some critical ui8-issue");
				setDisabled(false);
			});
		}catch(e){
			props.modalObject.ok("Kindly check and verify the input data,[ Do not use special characters]");
		}
	}  
	const getActionName=(_id)=>{
		const ACTIONS={
			"0":"Unseen",
			"1":"Accepted",
		    "2":"In Process",
			"3":"Resolved",
			"4":"Forwarded",
			"9":"Rejected"
		};
		return(ACTIONS[_id]);
	}
	return (
        <>
		<GlobalStyles />
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-hash'></i> Public Remarks</h5>
		<div className='card bg-light'>
		<div className="card-body">
		{fetchOnReq===true && 
			<>
				<img src={Waiter} className='waiter-md'/>
			</>
		}
		{(fetchOnReq===false && rows.length>=1) && 
		
			<table id="w3DListTable" className="table table-sm" style={{width:"99%",fontSize:'0.92rem'}}>
				<thead>
					<tr>
						<td><span>Slno</span></td>
						<td><span></span></td>
						{cols.map((item,i)=>{
							return(
								<th key={'tfx423_'+i}><span>{item}</span></th>	
							)
						})
						}
					  
					</tr>
				</thead>
				<tbody>
					{rows.map((item,i)=>{
							return(
								<tr key={'t423_'+i}>
									<td>{(i+1)}</td>
									<td nowrap>
										<div style={{whiteSpace: "nowrap"}}><a target='_blank' href={'https://jamshedpurgramsampati.in/public/document-details.php?vi='+item.assetId} >View</a>
										&nbsp;|&nbsp;<span className="cursor-pointer text-primary" data={item.slno+"::"+item.implAgencyId+"::"+item.assetId} onClick={async(e)=>{
															const data=e.target.getAttribute("data").split("::");
															await getActionRemarks(data[0]);
															setRecordSlno(data[0]);
															setImplAgencyId(data[1]);
															setAssetId(data[2]);
															setShowActionBox(true);
															return(false);
														}} >action</span>
										&nbsp;<span class="border rounded-pill px-2 border-info" style={{fontSize:"0.75rem"}}>{getActionName(item.status)}</span>
										</div>
									</td>
									<td>{getAssetType(item.assetType)}</td>
									<td>{item.mobile}</td>
									<td><div class='border rounded-2 p-2 bg-info'>{item.remarks}</div></td>
									<td>{ item.photo && item.photo.length>=5 &&
										<div 
														data={item.photo}
														className="cursor-pointer badge bg-primary"
														onClick={e=>{
															
															setSelectedVideo([e.target.getAttribute("data")]);
															setShowQRBox(true);
														}}
										>Play</div>
													}</td>
									<td className="starColor">{item.rates} <span className={'star'+item.rates}></span></td>
									<td>{item.idate}</td>
									<td>{getImplAgencyById(item.implAgencyId)}</td>
									<td>{getUserAgencyById(item.userAgency)}</td>
									<td>{item.panchayat}</td>
									<td>{item.block}</td>
								</tr>	
							)
				   })
				   }
				</tbody>
				
			</table>
		}
		</div>	
		</div>
		{showQRBox===true &&
		<>
		<div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
			<div className="d-flex justify-content-end p-4 position-relative">
				<div className="cursor-pointer text-dark position-absolute top-0 right-0" onClick={()=>{
					setShowQRBox(false);
				}}>Close</div>
			</div>
			<div className='d-flex vh-100 align-items-center'>
				<div className='row vw-100' style={{marginTop:'-8rem'}}>
				<div className='col-md-5 mx-auto border rounded-2 p-4'>
					<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Photo </div>
					<div className='text-center text-black fs-6'  >
					<video width="400" controls>
						<source src={"https://gramsampati.in/_apivideo/"+selectedVideo} type="video/mp4" />
						Your browser does not support HTML video.
					</video>
					</div>
					<div className='pt-4 text-end' >
						<button className='btn btn-secondary' onClick={()=>{
						setShowQRBox(false);
						}}>Close</button>
					</div>
				</div>
				</div>
			</div>
		</div>
		</>
		}
		{showActionBox===true &&
		<>
		<div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.97}}>
			<div className="d-flex justify-content-end p-4 position-relative">
				<div className="cursor-pointer text-dark position-absolute top-0 right-0" onClick={()=>{
					setShowActionBox(false);
				}}>Close</div>
			</div>
			<div className='d-flex vh-100 align-items-center'>
				<div className='row vw-100' style={{marginTop:'-8rem'}}>
				<div className='col-md-5 mx-auto border rounded-2 p-4'>
					<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Action </div>
					<div className=''  >
						<div className='row'>
							<div className='col-12'>
								<div className="form-floating mb-3 mt-3">
									<select type="select" onChange={e=>setActionType(e.target.value)} 
									className="form-select jform-select" id="actionType"  
									placeholder="select action type"
									onBlur={(e)=>_vli(e)} check='mixed' minLen='1' maxLength='64'
									>
										<option value=""></option>
										<option value="Accepted">Accepted</option>
										<option value="In Process">In Process</option>
										<option value="Forwarded">Forward</option>
										<option value="Rejected">Rejected</option>
										<option value="Resolved">Resolved</option>
									</select>
									<label>Action to </label>
								</div>
							</div>
							{ actionType=="Forwarded"?
							<div className='col-12'>
								<div className="form-floating mb-3 mt-3">
									<select type="select"  
									className="form-select jform-select" id="actionType"  
									placeholder="select implementing agency"
									onChange={e=>setImplAgencyIdForward(e.target.value)}
									>
										<option value=""></option>
										{
											actionType=="Forwarded" && implAgencyList.map((item,index)=>{
												return(
													<option value={item.implAgencyId}>{item.implAgencyName}</option>
												)
											})
										}
									</select>
									<label>Implementing Agency</label>
								</div>
							</div>
							:<></>
							}
							<div className='col-12'>		
							<div className="form-floating mb-3 mt-3">
									<textarea rows="6" style={{height:"6rem"}} className="form-control jform-control" id="remarks"   
									placeholder="Enter remarks"   
									onChange={e=>setRemarks(e.target.value)}
									onBlur={(e)=>_vli(e)} check='mixed' minLen='1' maxLength='1024'
									></textarea>
									<label>Remarks</label>
								</div>
							</div>
							
						</div>
					</div>
					<div className='pt-4 text-end' >
						<button className='btn btn-secondary mr-2 me-2' onClick={()=>{
						setShowActionBox(false);
						}}>Close</button>
						<button className='btn btn-primary'
						 disabled={disabled}
						 onClick={()=>{
							_vlai();
							let redBoxes=$(".form-control-error");
							if(redBoxes && redBoxes.length===0)
								props.modalObject.yesNo("Sure you want to submit record?",submitForm);
							else props.modalObject.ok("kindly fill all required details");
							
						}}>Submit</button>
					</div>
					<div  className='pt-4'>
						{
							(actionRemarks!=null && actionRemarks.length>0) ?
							<>
							{ 
								actionRemarks.map((item,index)=>{
								return(
									<div className="card p-2 bg-light mb-4">
										<div className='text-dark' style={{fontSize:'0.85rem'}}>{item.idate} [ <span className="text-success">{getImplAgencyById(item.implId)} </span>]</div>
										<div>{item.remarks}</div>
										<div className="text-end"><span className="px-2 text-success rounded-pill border" style={{fontSize:'0.85rem'}}>{item.actionType}</span></div>
									</div>
								)
								})
							}
							</>
							:
							<>-</>

						}
					</div>
				</div>
				</div>
			</div>
		</div>
		</>
		}
        </>
    )
}

export default JComponent;